export default class Idle {
  isUserAway: boolean = false;

  awayTimestamp: number = 0;

  awayTimeout: number = 3000;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  listener?: (_: Event) => void = undefined;

  awayTimer: null | NodeJS.Timeout = null;

  onAway: null | Function = null;

  onAwayBack: null | Function = null;

  onVisible: null | Function = null;

  onHidden: null | Function = null;

  constructor(options: {
    onAway: null | Function;
    onAwayBack: null | Function;
    awayTimeout: number;
    onVisible: null | Function;
    onHidden: null | Function;
  }) {
    const activeMethod: {
      [key: string]: undefined | null | Function;
    } = {};
    const activity: Idle = this;

    if (options) {
      activity.awayTimeout = options.awayTimeout;
      activity.onAway = options.onAway;
      activity.onAwayBack = options.onAwayBack;
      activity.onVisible = options.onVisible;
      activity.onHidden = options.onHidden;
    }

    activeMethod.$$onload = window.onload;
    activeMethod.$$onclick = window.onclick;
    activeMethod.$$onmousemove = window.onmousemove;
    activeMethod.$$onmousedown = window.onmousedown;
    activeMethod.$$ontouchstart = window.ontouchstart;
    activeMethod.$$onkeydown = window.onkeydown;
    activeMethod.$$onscroll = window.onscroll;
    activeMethod.$$onmousewheel = window.onmousewheel;
    activeMethod.$$focus = window.onfocus;

    window.onload = () => {
      if (activeMethod.$$onload) {
        activeMethod.$$onload();
      }
      activity.onActive();
    };
    window.onclick = () => {
      if (activeMethod.$$onclick) {
        activeMethod.$$onclick();
      }
      activity.onActive();
    };
    window.onmousemove = () => {
      if (activeMethod.$$onmousemove) {
        activeMethod.$$onmousemove();
      }
      activity.onActive();
    };

    window.onmousedown = () => {
      if (activeMethod.$$onmousedown) {
        activeMethod.$$onmousedown();
      }
      activity.onActive();
    };

    window.ontouchstart = () => {
      if (activeMethod.$$ontouchstart) {
        activeMethod.$$ontouchstart();
      }
      activity.onActive();
    };

    window.onkeydown = () => {
      if (activeMethod.$$onkeydown) {
        activeMethod.$$onkeydown();
      }
      activity.onActive();
    };

    window.onscroll = () => {
      if (activeMethod.$onscroll) {
        if (activeMethod.$$onscroll) {
          activeMethod.$$onscroll();
        }
      }
      activity.onActive();
    };

    window.onmousewheel = () => {
      if (activeMethod.$$onmousewheel) {
        activeMethod.$$onmousewheel();
      }
      activity.onActive();
    };

    window.onfocus = () => {
      if (activeMethod.$$focus) {
        activeMethod.$$focus();
      }
      activity.onActive();
    };
  }

  onActive() {
    this.awayTimestamp = new Date().getTime() + this.awayTimeout;

    if (this.isUserAway) {
      if (this.onAwayBack) {
        this.onAwayBack();
      }
      this.start();
    }

    this.isUserAway = false;

    return true;
  }

  start() {
    const activity: Idle = this;

    if (this.listener === undefined) {
      this.listener = (e) => {
        activity.handleVisibilityChange(e);
      };

      if (typeof document.addEventListener === 'function') {
        if (typeof document.hidden !== 'undefined') {
          document.addEventListener('visibilitychange', this.listener, false);
        } else {
          document.addEventListener('webkitvisibilitychange', this.listener, false);
        }
      }
    }

    this.awayTimestamp = new Date().getTime() + this.awayTimeout;

    if (this.awayTimer !== null) {
      clearTimeout(this.awayTimer);
    }

    this.awayTimer = setTimeout(() => {
      return activity.checkAway();
    }, this.awayTimeout + 100);

    return this;
  }

  stop() {
    if (this.awayTimer !== null) {
      clearTimeout(this.awayTimer);
    }

    if (this.listener !== undefined) {
      if (typeof document.removeEventListener === 'function') {
        if (typeof document.hidden !== 'undefined') {
          document.removeEventListener('visibilitychange', this.listener, true);
        } else {
          document.removeEventListener('webkitvisibilitychange', this.listener, true);
        }
      }
    }

    return this;
  }

  setAwayTimeout(ms: string) {
    this.awayTimeout = parseInt(ms, 10);
    return this;
  }

  checkAway() {
    const activity: Idle = this;
    const currentTime = new Date().getTime();

    if (currentTime < this.awayTimestamp) {
      this.isUserAway = false;

      this.awayTimer = setTimeout(() => {
        return activity.checkAway();
      }, this.awayTimestamp - currentTime + 100);

      return;
    }

    if (this.awayTimer !== null) {
      clearTimeout(this.awayTimer);
    }

    this.isUserAway = true;

    if (this.onAway !== null) {
      this.onAway();
    }
  }

  handleVisibilityChange(event: Event) {
    if (!document.hasFocus()) {
      if (this.onHidden && 'hidden' in document && document.hidden === false) {
        this.onHidden(event);
      }
    } else if (this.onVisible) {
      this.onVisible(event);
    }
  }
}
